import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForDigitalOrderConfigComponent extends Component {
  // Defaults
  availableFilters = [
    ...this.defaultFilters,
    {
      key: 'sourceType',
      options: ['product', 'download', 'external_promoter'],
      type: 'selectValueLabel',
    },
  ];

  defaultColumns = [
    'id',
    'headline',
    'sourceType',
    'articleNumber',
    'artist',
    'cmsModified',
  ];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'headline',
      sortable: true,
      isMainColumn: true,
    },
    {
      property: 'sourceType',
      sortable: true,
      type: 'translate-value',
    },
    {
      property: 'articleNumber',
      sortable: true,
    },
    {
      property: 'artist',
      sortable: true,
    },
    {
      property: 'cmsState',
      sortable: true,
      type: 'translate-value',
      align: 'right',
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];
}
